export default class ElementWatcher {
    /**
     *
     * @param string variable
     * @param boolean update
     * @param any element
     * @param any target
     */
    constructor(variable, update, element, target) {
        this.variable = variable;
        this.update = update;
        this.element = element;
        this.target = target;
        this.height;

        this.addEvents();
        this.watch();
    }

    addEvents() {
        if (this.update) {
            window.addEventListener('resize', () => {
                this.watch();
            });
        }
    }

    getElementHeight() {
        this.height = this.element.clientHeight;
    }

    watch() {
        this.element.style.removeProperty(this.variable);
        this.getElementHeight();
        this.target.style.setProperty(this.variable, `${this.height}px`);
    }
}
